module.exports = __webpack_public_path__ + "static/media/logo-nintendo.38cf9983.svg";